import { calculateQty } from '@apgnext/frontend/legacy/js/components/organisms/productGallery/utils/calgulateQty';
import styles from './CustomStyles.module.scss';

export const customStylesQuote = {
  textQuote: styles.textQuote,
  textAuthor: styles.textAuthor,
  textWrapper: styles.textWrapper,
};

export const calcQty = (props) => calculateQty(props);

export const theme = '';
